import React, {FC, useEffect, useState} from 'react'
import {KTIcon, KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field} from 'formik'
import {ICreateAccount, inits as initialValues} from '../CreateAccountWizardHelper'
import {ModalReaded} from './ModalReaded'
import {htmlData} from '../../../auth/components/middleware/htmlData'

const Step11: any = ({handleGetCheckFinalStep, setActiveStep}: any) => {
  const data = initialValues
  const [isReadToggle, setIsReadToggle] = useState(data.haveReadHD)

  const handleCheckedHaveRead = (e: any) => {
    if (e.target.checked === true) {
      setActiveStep(false)
    } else {
      setActiveStep(true)
    }

    setIsReadToggle(e.target.checked)
    handleGetCheckFinalStep(e.target.checked)
  }

  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Xác nhận điều khoản hợp đồng</h2>
        </div>

        <div className='mb-10 fv-row border p-4 rounded mt-5 content-di'>
          <div dangerouslySetInnerHTML={{__html: htmlData}}></div>
        </div>
      </div>

      <div className='fv-row'>
        <div
          className='d-flex align-items-center mt-3'
          // data-bs-toggle={isReadToggle === false ? 'modal' : ''}
          // data-bs-target={isReadToggle === false ? '#kt_modal_1' : ''}
        >
          <label className='form-check form-check-inline form-check-solid me-5 text-hover-primary'>
            <Field
              type='checkbox'
              name='haveReadHD'
              className='form-check-input w-25px h-25px'
              onClick={handleCheckedHaveRead}
            />
            <span className='fw-bold ps-2 fs-6'>
              Tôi đã đọc và đồng ý với các điều khoản Hợp đồng mở và sử dụng tài khoản tại Chứng
              khoán NH Việt Nam
            </span>
            <div className='text-danger mt-2'>
              <ErrorMessage component='span' name='haveReadHD' />
            </div>
          </label>
        </div>
      </div>

      {isReadToggle === true ? <></> : null}

      {/* <ModalReaded /> */}
    </div>
  )
}

export {Step11}
